import buttonStyles from "../../../styles/UI/buttons.module.css";
const TabButton = ({
  tabTitle,
  selected,
  onClick,
  fullWidth,
}: {
  tabTitle: string;
  selected: string;
  onClick: (value: string) => void;
  fullWidth?: boolean;
}) => {
  return (
    <button
      onClick={() => onClick(tabTitle)}
      className={`${buttonStyles.tabButton} ${
        selected === tabTitle
          ? buttonStyles.tabButtonSelected
          : buttonStyles.tabButton
      } ${fullWidth ? "w-full" : "w-fit"}`}
    >
      {tabTitle}
    </button>
  );
};

export default TabButton;
